<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>

        <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">{{ $t('order.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valOrderSn"
            :placeholder="$t('order.inp.order_no')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('device.no') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDeviceId"
            :placeholder="$t('order.inp.device_no')"></el-input>
        </div>
        <!-- <div class="item">
          <span class="label">{{ $t('device.deposit') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDeposit"
            :placeholder="$t('device.deposit')"></el-input>
        </div> -->
        <div class="item">
          <span class="label">{{ $t('order.nickname') }}</span>
          <el-input class="inp" size="small" v-model="formData.valTel" :placeholder="$t('order.inp.name')"></el-input>
        </div>
        <!-- <div class="item">
          <span class="label">{{ $t('g.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.idName" :placeholder="$t('g.enter_name')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('member.mobile') }}</span>
          <el-input class="inp" size="small" v-model="formData.valPhone" :placeholder="$t('member.mobile')"></el-input>
        </div> -->
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" style="width: 100%" @row-click="func.showDetails">
        <el-table-column prop="Id" label="Id" width="90" v-if="!isOperator()">
        </el-table-column>
        <el-table-column prop="OrderSn" :label="$t('order.no')" width="190">
        </el-table-column>
        <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('g.agent_code')" width="80">
        </el-table-column>
        <el-table-column prop="UserInfo.Id" width="80" :label="$t('order.userId')">
        </el-table-column>
        <el-table-column prop="UserInfo.Nickname" width="100" :label="$t('bill.nickname')">
        </el-table-column>
        <!-- <el-table-column prop="UserInfo.Mobile" width="120" :label="$t('member.mobile')">
        </el-table-column>
        <el-table-column prop="UserInfo.IdName" width="80" :label="$t('member.IdName')">
        </el-table-column> -->
        <el-table-column min-width="100" label="支付状态" prop="StatusStr">
          <template #default="scope">
            <el-tag
              :class="scope.row.StatusStr == $t('member.statuses.success') ? 'tag-success' : (scope.row.StatusStr == $t('order.unpayed') ? 'tag-warning' : 'tag-fail')">
              {{ scope.row.StatusStr }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="100" label="还车状态">
          <template #default="scope">
            <el-tag v-if="scope.row.BikeReturnOrder?.Status == 0">取电中</el-tag>
            <el-tag v-if="scope.row.BikeReturnOrder?.Status == 1">取电成功</el-tag>
            <el-tag v-if="scope.row.BikeReturnOrder?.Status == 2" class="tag-fail">取电失败</el-tag>
            <el-tag v-if="scope.row.BikeReturnOrder?.Status == 3" class="tag-success">还车成功</el-tag>
            <el-tag v-if="scope.row.BikeReturnOrder?.Status == 4" class="tag-fail">还车失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="DeviceId" width="250" :label="$t('order.CabinetNumber')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="DeviceSiteName" width="120" :label="$t('device.site_name')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.BikeId" min-width="100" :label="$t('order.vehicleNumber')"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.BatId" min-width="250" :label="$t('member.battery_no')"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.BatSOC" width="100" :label="$t('device.battery_soc')">
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.ActualDuration" width="100" :label="$t('order.LeaseDuration')">
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.Price" width="100" :label="$t('order.RentalCosts')">
          <template #default="scope">
            <span v-if="scope.row.BikeReturnOrder?.Price">{{ scope.row.BikeReturnOrder?.Price / 100 }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.Deposit" width="80" :label="$t('device.deposit')">
          <template #default="scope">
            <span v-if="scope.row.BikeReturnOrder?.Deposit">{{ scope.row.BikeReturnOrder?.Deposit / 100 }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column prop="PayWayStr" width="100" :label="$t('order.pay_way')">
        </el-table-column>
        <el-table-column prop="NamePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="BikeReturnOrder.UpdatedAtStr" width="200" label="还车时间">
        </el-table-column>
        <el-table-column prop="CreatedAtStr" width="200" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column width="150" :label="$t('order.failed_reason')" prop="FailReason" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="Remark" width="120" :label="$t('order.remark')" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column width="100" :label="$t('g.operation')" fixed="right">
          <template #default="scope">

            <el-button @click="func.onRefund(scope.row)" :class="scope.row.Status != 0 ? 'btn-add' : 'tag-info'"
              :disabled="scope.row.Status == 0" type="info">退款</el-button>

          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" style="width:90%" align-center>
      <el-descriptions border column="4">
        <el-descriptions-item :label="$t('order.no')">{{ formData.curData.OrderSn }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.mobile')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Mobile
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('bill.nickname')">
          <el-link type="primary" @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.Nickname
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('member.IdName')"> <el-link type="primary"
            @click="formData.userDrawerVisible = true">{{ formData.curData.UserInfo?.IdName
            }}</el-link></el-descriptions-item>
        <el-descriptions-item :label="$t('order.CabinetNumber')">
          <el-link type="primary" @click="formData.devDrawerVisible = true">{{ formData.curData.DeviceId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="仓门">{{ formData.curData.BikeReturnOrder.BoxSlotId }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.site_name')">{{ formData.curData.DeviceSiteName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('member.battery_no')">
          <el-link type="primary" @click="formData.batDrawerVisible = true">{{ formData.curData?.BikeReturnOrder?.BatId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.battery_soc')">{{ formData.curData?.BikeReturnOrder?.BatSOC
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.vehicleNumber')">{{ formData.curData?.BikeReturnOrder?.BikeId
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.deposit')">
          <span v-if="formData.curData?.BikeReturnOrder?.Deposit">{{ formData.curData?.BikeReturnOrder?.Deposit / 100
          }}</span>
          <span v-else>0</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.rentType')">{{
          formData.curData.Type == 16 ? $t('order.rentAndCombo') : $t('order.commonRent') }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.pay_way')">{{ formData.curData.PayWayStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.LeaseDuration')">{{ formData.curData.BikeReturnOrder.ActualDuration
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.RentalCosts')">
          <span v-if="formData.curData.BikeReturnOrder?.Price">{{ formData.curData.BikeReturnOrder?.Price / 100
          }}</span>
          <span v-else>0</span>
        </el-descriptions-item>
        <!-- <el-descriptions-item :label="$t('order.CarStartTime')">{{ formData.curData.BikeReturnOrder.ST }}</el-descriptions-item> -->
        <el-descriptions-item label="还车时间">{{ formData.curData.BikeReturnOrder.UpdatedAtStr }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.PaymentStatus.name')">
          <el-tag
            :class="formData.curData.StatusStr == $t('member.statuses.success') ? 'tag-success' : (formData.curData.StatusStr == $t('order.unpayed') ? 'tag-warning' : 'tag-fail')">
            {{ formData.curData.StatusStr }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="还车状态">
          <el-tag v-if="formData.curData.BikeReturnOrder?.Status == 0">取电中</el-tag>
          <el-tag v-if="formData.curData.BikeReturnOrder?.Status == 1">取电成功</el-tag>
          <el-tag v-if="formData.curData.BikeReturnOrder?.Status == 2" class="tag-fail">取电失败</el-tag>
          <el-tag v-if="formData.curData.BikeReturnOrder?.Status == 3" class="tag-success">还车成功</el-tag>
          <el-tag v-if="formData.curData.BikeReturnOrder?.Status == 4" class="tag-fail">还车失败</el-tag>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('order.failed_reason')">{{ formData.curData.FailReason
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')" :span="1">{{ formData.curData.CreatedAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')" :span="3">{{ formData.curData.NamePath
        }}</el-descriptions-item>
        <!-- <el-descriptions-item :label="$t('order.event')" :span="4">
          <div v-for="item in formData.curData.eboxEvent">
            {{ item.Type }} {{ item.CreatedAtStr }}
          </div>
        </el-descriptions-item> -->
      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.devDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <EboxList :propId="formData.curData.DeviceId"></EboxList>
    </el-drawer>
    <el-drawer v-model="formData.batDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <BatteryList :propId="formData.curData?.BikeReturnOrder?.BatId"></BatteryList>
    </el-drawer>
    <el-drawer v-model="formData.userDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <MemberList :propId="formData.curData.UserInfo.Id"></MemberList>
    </el-drawer>
  </div>
</template>

<script>
import { dayjs } from 'element-plus'
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import EboxList from '@/views/ebox/list.vue'
import BatteryList from '@/views/battery/list.vue'
import MemberList from '@/views/member/list.vue'
export default {
  name: 'OrderBattery',
  components: {
    EboxList,
    BatteryList,
    MemberList
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: -1
      },
      {
        label: t('member.statuses.success'),
        value: 1
      },
      {
        label: t('member.statuses.failed'),
        value: 0
      },
      {
        label: t('member.statuses.returned'),
        value: 2
      },
      {
        label: t('bill.rs.refunding'),
        value: 3
      },
      {
        label: t('bill.rs.refundfail'),
        value: 4
      },
    ]
    const render = {
      shortcuts,
      statuses,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      CodePathID: 0,
      valStatus: -1,
      valTime: '',
      valTel: '',
      IdName: '',
      valOrderSn: '',
      dialogDisplayVisible: false,
      dialogRefundVisible: false,
      devDrawerVisible: false,
      batDrawerVisible: false,
      userDrawerVisible: false,
      valDeviceId: '',
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true,
      },
    })
    const func = {

      onRefund(row) {
        formData.curData = row;
        formData.dialogRefundVisible = true
      },
      showDetails(row, column) {
        if (column && column.label == t('g.operation')) {
          return;
        }
        formData.dialogDisplayVisible = true;
        formData.curData = row;
        //func.getEboxEvent(formData.curData.OrderSn)
      },
      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      refresh() {
        formData.CodePathID = 0
        formData.valStatus = -1
        formData.valTime = ''
        formData.idName = ''
        formData.valTel = ''
        func.loadData(1)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.valOrderSn) {
            params.OrderSn = formData.valOrderSn
          }
          // if (formData.valDeviceId) {
          //   params.deviceId = formData.valDeviceId
          // }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          // if (formData.valTel) {
          //   params.nickname = formData.valTel
          // }
          // if (formData.idName) {
          //   params.idName = formData.idName
          // }
          // if (formData.valPhone) {
          //   params.phoneNum = formData.valPhone
          // }
          // if (formData.valDeposit) {
          //   params.orderPrice = formData.valDeposit
          // }
          // if (formData.valStatus != -1) {
          //   params.status = formData.valStatus
          // }
          // params.DeviceStatus = formData.valStatus
          if (formData.valTime) {
            params.StartAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.EndAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          console.log(JSON.stringify(params));

          let res = await axios.get(`/admin/order/bikereturn`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            if (item.BikeReturnOrder.UpdatedAtStr != 0) {
              item.BikeReturnOrder.UpdatedAtStr = toDay(item.BikeReturnOrder.UpdatedAt)
            } else {
              item.BikeReturnOrder.UpdatedAtStr = ''
            }
            switch (item.Status) {
              case 0:
                item.StatusStr = t('order.unpayed')
                break;
              case 1:
                item.StatusStr = t('member.statuses.success')
                break;
              case 2:
                item.StatusStr = t('bill.rs.refunded')
                break;
              case 3:
                item.StatusStr = t('bill.rs.refunding')
                break;
              case 4:
                item.StatusStr = t('bill.rs.refundfail')
                break;
              default:
                item.StatusStr = t('member.statuses.failed')
            }
            if (item.PayWay == 1) {
              item.PayWayStr = t('order.pay_ways.balance')
            } else if (item.PayWay == 2) {
              item.PayWayStr = t('order.pay_ways.wechat')
            }
            if (item.BikeReturnOrder?.ST) {
              item.BikeReturnOrder.ST = toDay(item.BikeReturnOrder.ST)
              console.log(item.BikeReturnOrder.ST, '值1111')
            }
            if (item.BikeReturnOrder?.ETC) {
              item.BikeReturnOrder.ETC = toDay(item.BikeReturnOrder.ETC)
            }

          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators() 
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .inp-block {
    display: block;
  }

  .table-expand {
    padding-left: 4rem;
    padding-top: 1rem;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  // >.data-table {
  //   :deep(.el-table) {
  //     .cell {
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //     }

  //     .el-table__row {
  //       cursor: pointer;
  //     }
  //   }
  // }



  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 70rem;
    // margin-top: 0;
  }
}
</style>